export default "__VITE_ASSET__Cl1Fov2X__"